module.exports = __webpack_public_path__ + "assets/img/dongtu-2.8ebc3da0.gif";